import { render, staticRenderFns } from "./MassEmails.vue?vue&type=template&id=23e7aa2c&scoped=true&"
import script from "./MassEmails.vue?vue&type=script&lang=js&"
export * from "./MassEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e7aa2c",
  null
  
)

export default component.exports